<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="pagination"
    @change="onChange"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Month'">
        {{ record.period_label || record.period }}
      </template>

      <template v-else-if="column.key === 'Loan'">
        <div class="d-flex align-items-center">
          <div class="ms-0">
            <p class="text-dark mb-0">{{ record.employee_name }}</p>
            <span class="fs-12">
              {{ record.employee_id }}
              <span v-if="record.loan_type"> • {{ record.loan_type }}</span>
              <span v-if="record.department"> • {{ record.department }}</span>
            </span>
          </div>
        </div>
      </template>

      <template v-else-if="moneyColumns.includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.dataIndex] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>

      <template v-else-if="column.key === 'Rate'">
        {{ Number(record.interest_rate || 0).toFixed(2) }}%
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
  total: { type: Number, default: 0 },
  pageSize: { type: Number, default: 25 },
  current: { type: Number, default: 1 },
});
const emit = defineEmits(["change"]);

const columns = [
  { title: "Month", dataIndex: "period_label", key: "Month" },
  { title: "Loan / Employee", dataIndex: "employee_name", key: "Loan" },
  { title: "Principal", dataIndex: "principal", key: "Principal" },
  { title: "Interest Rate", dataIndex: "interest_rate", key: "Rate" },
  { title: "Interest Earned", dataIndex: "interest_amount", key: "Interest" },
  { title: "Outstanding Balance", dataIndex: "balance_remaining", key: "Balance" },
];

const moneyColumns = ["Principal", "Interest", "Balance"];

const dataSource = computed(() =>
  (props.rows || []).map((r, idx) => ({
    key: r.id || `${r.period || "p"}-${r.loan_id || idx}-${idx}`,
    id: r.id,
    period: r.period,
    period_label: r.period_label,

    employee_id: r.employee_id,
    employee_name: r.employee_name,
    department: r.department,
    loan_type: r.loan_type,
    loan_id: r.loan_id,

    principal: r.principal,
    interest_rate: r.interest_rate,
    interest_amount: r.interest_amount,
    balance_remaining: r.balance_remaining,
  }))
);

const pagination = computed(() => ({
  total: props.total,
  pageSize: props.pageSize,
  current: props.current,
  showTotal: (t) => `Total ${t} items`,
}));

function onChange(pagination, filters, sorter) {
  emit("change", pagination, filters, sorter);
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 820px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
